(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("1KrrA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8b5ddcb7daf491bb$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
parcelRequire("dTCkE");

var $9LXOV = parcelRequire("9LXOV");

var $OdqFX = parcelRequire("OdqFX");

var $fp4AW = parcelRequire("fp4AW");

const $8b5ddcb7daf491bb$var$OfficePageProvider = ({ pageId: pageId, archiveId: archiveId })=>{
    const searchParams = new URLSearchParams(window.location.search);
    const brokerQueryFromSearch = searchParams?.get("broker");
    const pathname = window.location.pathname;
    const pathSegments = pathname.split("/");
    const medarbetareIndex = pathSegments.indexOf("medarbetare");
    const brokerQueryFromPath = medarbetareIndex !== -1 ? decodeURIComponent(pathSegments[medarbetareIndex + 1]) : null;
    const brokerQuery = brokerQueryFromSearch || brokerQueryFromPath;
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $9LXOV.default), {
        pageId: pageId,
        archiveId: archiveId,
        children: brokerQuery ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $fp4AW.default), {
            brokerQuery: brokerQuery
        }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $OdqFX.default), {})
    });
};
var $8b5ddcb7daf491bb$export$2e2bcd8739ae039 = $8b5ddcb7daf491bb$var$OfficePageProvider;

});
parcelRegister("OdqFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972852b4038c320b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $9LXOV = parcelRequire("9LXOV");

var $1h3ki = parcelRequire("1h3ki");

var $kJZ4R = parcelRequire("kJZ4R");

var $4F0i8 = parcelRequire("4F0i8");

const $972852b4038c320b$var$OfficePageHero = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("jfCDC")));

const $972852b4038c320b$var$OfficeBreadcrumbs = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("kXozw")));

const $972852b4038c320b$var$OfficeTopMenu = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("5ulGH")));

const $972852b4038c320b$var$OfficeBrokers = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("1VRpj")));

const $972852b4038c320b$var$OfficeObjects = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("fgwv7")));

const $972852b4038c320b$var$OfficeSoldObjects = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("cdiq6")));

const $972852b4038c320b$var$OfficePartners = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("blxn8")));

const $972852b4038c320b$var$OfficeLocalAreas = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("7vcjZ")));

const $972852b4038c320b$var$OfficeNews = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("6RWiY")));

const $972852b4038c320b$var$BlockList = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("hvnG1")));

const $972852b4038c320b$var$ContactForm = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("a3GHK")));
const $972852b4038c320b$var$OfficePageNew = ()=>{
    const { officeAdminPage: officeAdminPage, office: office, archiveId: archiveId } = (0, $dTCkE.useContext)((0, $9LXOV.OfficePageContext));
    const globalPartners = officeAdminPage?.properties?.globalPartnerList?.items;
    const officePartners = office?.properties?.partnerList?.items;
    const officeLocalAreas = office?.properties?.localAreas?.items;
    const customerId = office?.properties?.officeId;
    const mirrorId = office?.properties?.mirrorIds;
    const { data: soldOfficeEstateInfo, isLoading: loadingSoldObjects } = (0, $1h3ki.default)(customerId, false, false, true, mirrorId);
    //this is to fetch news
    const NEWSARCHIVE_ID = archiveId;
    const { data: officeNewsUmbraco } = (0, $kJZ4R.default)(office?.id);
    const { data: nationalNewsUmbraco } = (0, $4F0i8.default)(NEWSARCHIVE_ID, "Nationellt arkiv" //this needs to be the node name of national news archive
    );
    const { data: countyNewsUmbraco } = (0, $4F0i8.default)(NEWSARCHIVE_ID, office?.properties?.officeCounty ? `${office?.properties?.officeCounty} arkiv` : null);
    //sorts and merge county and office news
    const sortedCountyAndOfficeNews = [
        ...countyNewsUmbraco?.items || [],
        ...officeNewsUmbraco?.items || []
    ].sort((a, b)=>new Date(b.createDate).getTime() - new Date(a.createDate).getTime());
    //merged all news
    const mergedAllNews = [
        ...nationalNewsUmbraco?.items || [],
        ...sortedCountyAndOfficeNews
    ];
    const [newsAmount, setNewsAmount] = (0, $dTCkE.useState)(3);
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeTopMenu, {
                        loadingSoldObjects: loadingSoldObjects,
                        showSoldObjects: soldOfficeEstateInfo?.totalLength > 0,
                        newsExist: mergedAllNews?.length > 0
                    })
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "m-auto lg:mt-13 w-full max-w-[1680px]",
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficePageHero, {})
                    })
                }),
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "mx-auto w-full max-w-container",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeBreadcrumbs, {})
                        }),
                        mergedAllNews && mergedAllNews?.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeNews, {
                                news: mergedAllNews
                            })
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeObjects, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeBrokers, {})
                }),
                officeAdminPage?.properties?.blockListCenter?.items && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$BlockList, {
                        blocks: officeAdminPage?.properties?.blockListCenter?.items
                    })
                }),
                officeAdminPage?.properties?.showFormOffice && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$ContactForm, {
                        officeAdminPage: officeAdminPage,
                        office: office
                    })
                }),
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "mx-auto w-full max-w-container",
                    children: [
                        soldOfficeEstateInfo && soldOfficeEstateInfo?.totalLength > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeSoldObjects, {
                                officeEstateInfo: soldOfficeEstateInfo,
                                isLoading: loadingSoldObjects
                            })
                        }),
                        (globalPartners || officePartners) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficePartners, {})
                        })
                    ]
                }),
                officeAdminPage?.properties?.blockListBottom?.items && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$BlockList, {
                        blocks: officeAdminPage?.properties?.blockListBottom?.items
                    })
                }),
                officeLocalAreas && officeLocalAreas?.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "mx-auto w-full max-w-container",
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($972852b4038c320b$var$OfficeLocalAreas, {})
                    })
                })
            ]
        })
    });
};
var $972852b4038c320b$export$2e2bcd8739ae039 = $972852b4038c320b$var$OfficePageNew;

});
parcelRegister("1h3ki", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f25981fa25ad2c0$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $2f25981fa25ad2c0$var$useOfficeEstates = (officeId, forSale, headStart, sold, otherOffices)=>{
    return (0, $4cyLg.useQuery)([
        "officeEstates",
        officeId,
        forSale,
        headStart,
        sold
    ], ()=>(0, $1HGFx.EstatesService).estatesGetEstatesForOffice(officeId, forSale, headStart, sold, otherOffices).then((response)=>response), {
        enabled: forSale !== undefined || headStart !== undefined || sold !== undefined
    });
};
var $2f25981fa25ad2c0$export$2e2bcd8739ae039 = $2f25981fa25ad2c0$var$useOfficeEstates;

});

parcelRegister("kJZ4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668ca122e0cdd5f9$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");
const $668ca122e0cdd5f9$var$useUmbracoOfficeNews = (pageId)=>{
    return (0, $4cyLg.useQuery)([
        "umbracoOfficeNews",
        pageId
    ], ()=>fetch(`/umbraco/delivery/api/v2/content?fetch=descendants:${pageId}&sort=name:asc&filter=contentType:OfficeNewsItem&fields=properties[heading,image,text,preamble]&take=300`).then((response)=>{
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
        }), {
        enabled: !!pageId,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $668ca122e0cdd5f9$export$2e2bcd8739ae039 = $668ca122e0cdd5f9$var$useUmbracoOfficeNews;

});

parcelRegister("4F0i8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a945076d26d077b$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");
const $8a945076d26d077b$var$useUmbracoOfficeNews = (pageId, nodeName)=>{
    return (0, $4cyLg.useQuery)([
        "umbracoOfficeNews",
        pageId,
        nodeName
    ], async ()=>{
        // Fetch all descendants of the given pageId
        const response = await fetch(`/umbraco/delivery/api/v2/content?fetch=descendants:${pageId}&fields=name,id`);
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        // Find the child node with the specified nodeName
        const targetNode = data.items.find((item)=>item.name === nodeName);
        if (!targetNode) throw new Error(`Node with name "${nodeName}" not found`);
        // Fetch all descendants of the found node
        const descendantsResponse = await fetch(`/umbraco/delivery/api/v2/content?fetch=descendants:${targetNode.id}&sort=name:asc&fields=properties[heading,image,text,preamble]&take=300`);
        if (!descendantsResponse.ok) throw new Error("Failed to fetch descendants");
        return descendantsResponse.json();
    }, {
        enabled: !!pageId && !!nodeName,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $8a945076d26d077b$export$2e2bcd8739ae039 = $8a945076d26d077b$var$useUmbracoOfficeNews;

});

parcelRegister("jfCDC", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("dRpW7")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7FWfL"))
]).then(()=>parcelRequire("bGlgE"));

});

parcelRegister("kXozw", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("6EGDf")).then(()=>parcelRequire("f4UEf"));

});

parcelRegister("5ulGH", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cgZ0d")).then(()=>parcelRequire("lgvPQ"));

});

parcelRegister("1VRpj", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("emHmV"))
]).then(()=>parcelRequire("bLeSd"));

});

parcelRegister("fgwv7", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("zHfwy")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aCGyq")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bIRMW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3detd")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("95uzV"))
]).then(()=>parcelRequire("dkRDN"));

});

parcelRegister("cdiq6", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("zHfwy")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aCGyq")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bIRMW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3detd")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("eQn4I"))
]).then(()=>parcelRequire("lmASj"));

});

parcelRegister("blxn8", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("eNxBc")).then(()=>parcelRequire("bXRVi"));

});

parcelRegister("7vcjZ", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("fhAII"))
]).then(()=>parcelRequire("cOzOZ"));

});

parcelRegister("6RWiY", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bBvi9")).then(()=>parcelRequire("8T4Cy"));

});

parcelRegister("hvnG1", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("2ZL6u")).then(()=>parcelRequire("agtBJ"));

});

parcelRegister("a3GHK", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bop5H")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("1WDNe")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("iG5lV")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("gg0Ro")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3H1xp")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7rgMa")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("jc4ur")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("6RYDG"))
]).then(()=>parcelRequire("7UOR6"));

});



})();
//# sourceMappingURL=OfficePageProvider.38954462.js.map
